import { Cancel } from 'axios';
import { BaseError } from '../../errors/BaseError';

/**
 * キャンセルエラー例外
 */
export class ApiRequestCancelError extends BaseError implements Cancel {
  constructor(public message: string) {
    super();
  }
}
